import PersistenceService from '../ports/PersistenceService';

export default class LocalStorageService implements PersistenceService {
  setData = <T>(key: string, value: T) =>
    localStorage.setItem(key, JSON.stringify(value))
  getData = <T>(key: string) =>
    JSON.parse(localStorage.getItem(key) || 'null') as T | null
}
